import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  GitlabVersionUpgradeStatus,
  ResetDeployDevStatusDto,
  ResetDeployInfoEntity,
  ResetDeploymentEntity
} from '../model/GitlabVersionModel';
import { BaseurlService } from './baseurl.service';

@Injectable({
  providedIn: 'root'
})
export class GitlabService {

  constructor(
    private http: HttpClient,
    private baseurlService: BaseurlService,
  ) { }

  postNewVersion(version: string): Observable<GitlabVersionUpgradeStatus> {
    return this.http.post<GitlabVersionUpgradeStatus>(`${this.baseurlService.getBaseUrl()}/deployReset/gitlabVersion`, {version});
  }

  deployDevToDeployDev(): Observable<ResetDeployDevStatusDto> {
    return this.http.post<ResetDeployDevStatusDto>(`${this.baseurlService.getBaseUrl()}/deployReset/devToDeployDev`, null);
  }

  deployProd(stage: string, hash: string): Observable<ResetDeploymentEntity> {
    return this.http.put<ResetDeploymentEntity>(`${this.baseurlService.getBaseUrl()}/deployReset/${stage}/${hash}`, null);
  }

  getDeployables(): Observable<ResetDeployInfoEntity[]> {
    return this.http.get<ResetDeployInfoEntity[]>(`${this.baseurlService.getBaseUrl()}/deployReset`);
  }

  getGitCommitHashToNames(): Observable<Record<string, string>> {
    return this.http.get<Record<string, string>>(`${this.baseurlService.getBaseUrl()}/deployReset/gitCommitHashInfo`);
  }

}
